module.exports = __webpack_public_path__ + "images/tft-cards.webp";